import { Zap } from "lucide-react";
import { ProductGrid } from "./ProductGrid";
import { flashInfo } from "../lib/flash";

export const FlashDeals = ({ products, onOpen }) => {
  const deals = products.filter((p) => flashInfo(p).active);
  if (deals.length === 0) return null;
  return (
    <section id="offerte" className="scroll-mt-28 border-y border-terra/25 bg-panel/40 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="mb-10 flex items-center gap-3">
          <span className="grid h-11 w-11 place-items-center rounded-full bg-terra text-cream shadow-[0_0_26px_rgba(255,46,76,0.6)]">
            <Zap className="h-5 w-5" strokeWidth={2.5} />
          </span>
          <div>
            <p className="text-xs uppercase tracking-overline text-terra">Solo per poco · affrettati</p>
            <h2 className="font-serif text-4xl font-light leading-none text-ink md:text-5xl">Offerte lampo</h2>
          </div>
        </div>
        <ProductGrid products={deals} onOpen={onOpen} />
      </div>
    </section>
  );
};
